module.exports = __webpack_public_path__ + "img/Retail8.68acfbff.png";